<template>
  <ListItemsWithTableLayout>
    <template #body>
      <HandlerAccessDenied :is-denied="isDenied">
        <PlanTraficFilterForm
          :isFilterEnabled="isFilterEnabled"
          @toggle-filter="isFilterEnabled = !isFilterEnabled"
          @set-filter="setFilter" />
        <TopListTraficPlanPanel
          :isArchiveEnabled="isArchiveEnabled"
          :isFilterEnabled="isFilterEnabled"
          :isFilterSetted="isFilterSetted"
          @toggle-archive="toggleArchive"
          @set-common-filter="setCommonFilter"
          @toggle-filter="isFilterEnabled = !isFilterEnabled"
        ></TopListTraficPlanPanel>
        <div
          id="table-container"
          class="table-container flex flex-col"
          :class="[
            filteredCampaigns && filteredCampaigns.length == 0
              ? 'empty'
              : 'filled',
          ]"
        >
          <TraficPlanTable
            :campaigns="filteredCampaigns"
            :isArchiveEnabled="isArchiveEnabled"
            :isActiveFirst="activeFirstFromStore"
            :isLoading="isLoading"
            :rowsCount="rowsCount(46, 20) * tableDisplaySettings.first"
            @sort-table="sortTable"
            @update-table="updateCampaignsList"
          ></TraficPlanTable>
          <EmptyTableMessage
            v-if="
              filteredCampaigns && filteredCampaigns.length == 0 && !isLoading
            "
          >
            <template #text>
              Примените другой фильтр или создайте первую запись для плана
              трафика. <br />
              Для этого кликните на кнопку "Создать план трафика".
            </template>
          </EmptyTableMessage>
        </div>
        <Paginator
          v-model:first="tableDisplaySettings.first"
          @update:first="updateCampaignsList"
          :rows="1"
          class="s-paginator"
          :totalRecords="store.campaignsPagesCount"
          template="PrevPageLink CurrentPageReport NextPageLink"
          currentPageReportTemplate="{first} из {totalRecords}"
      /></HandlerAccessDenied>
    </template>
  </ListItemsWithTableLayout>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from "vue";

import Paginator from "primevue/paginator";
import TopListTraficPlanPanel from "@/entities/analytics/trafic_plan/panels/TopListTraficPlanPanel.vue";
import PlanTraficFilterForm from "@/entities/analytics/trafic_plan/forms/PlanTraficFilterForm.vue";
import ListItemsWithTableLayout from "@/widgets/layouts/ListItemsWithTableLayout.vue";
import EmptyTableMessage from "@/entities/segments/EmptyTableMessage.vue";
import TraficPlanTable from "@/entities/analytics/trafic_plan/TraficPlanTable.vue";
import HandlerAccessDenied from "@/shared/base/HandlerAccessDenied.vue";

import { useCampaignStore, CampaignsParams } from "@/store/campaigns/campaigns";
import { useCampaignsDictionariesStore } from "@/store/dictionaries/campaigns";
import { useAuthStore } from "@/store/auth/login";
import { FilterFormTraficPlan } from "@/services/campaigns/utils";
import { rowsCount } from "@/services/utils/Pagination";
import { setCampaignParamsByFilterWithTraficPlan } from "@/services/campaigns/utils";

const store = useCampaignStore();
const campaignsDictionariesStore = useCampaignsDictionariesStore();
const isArchiveEnabled = ref(false);
const isFilterEnabled = ref(false);
const isFilterSetted = ref(false);
const isLoading = ref(false);
const authStore = useAuthStore();
const tableDisplaySettings = ref({
  first: 0,
  orderField: "",
  isArchived: false,
  filter: {} as FilterFormTraficPlan,
  commonFilter: "",
});

const filteredCampaigns = computed(() => {
  return store.campaignsList;
});

const isDenied = computed(() => {
  return authStore.isDeniedForPermissions(
    ["system:edit"],
    ["analytics:edit"],
    ["campaign:read", "campaign:edit", "system:read"]
  );
});

onMounted(() => {
  if (isDenied.value) return;
  loadData();
});

const loadData = () => {
  isLoading.value = true;
  campaignsDictionariesStore.getStates().then(() => {
    tableDisplaySettings.value.stateIdIn =
      campaignsDictionariesStore.defaultStates;
    updateCampaignsList();
  });
  campaignsDictionariesStore.getSegmentsStates();
};

const activeFirstFromStore = computed(() => store.activeFirst);

const updateCampaignsList = () => {
  let isEnded = false;

  setTimeout(() => {
    if (!isEnded) {
      isLoading.value = true;
    }
  }, 200);

  const params: CampaignsParams = {
    page: tableDisplaySettings.value.first + 1,
    per_page: rowsCount(46, 20),
  };

  setCampaignParamsByFilterWithTraficPlan(params, tableDisplaySettings.value);

  store.getCampaigns(params).finally(() => {
    isLoading.value = false;
    isEnded = true;
  });
};
const toggleArchive = () => {
  isArchiveEnabled.value = !isArchiveEnabled.value;
  tableDisplaySettings.value.first = 0;
  if (isArchiveEnabled.value) tableDisplaySettings.value.isArchived = true;
  else tableDisplaySettings.value.isArchived = false;
  updateCampaignsList();
};

const setCommonFilter = (filter: string) => {
  tableDisplaySettings.value.commonFilter = filter;
  updateCampaignsList();
};

const setFilter = (filter: object, isSetted: boolean) => {
  tableDisplaySettings.value.filter = filter;
  isFilterSetted.value = isSetted;
  updateCampaignsList();
};

const sortTable = (order_by: string) => {
  tableDisplaySettings.value.orderField = order_by;
  updateCampaignsList();
};

let resizeTimeout: number;

window.addEventListener("resize", function () {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(updateCampaignsList, 200);
});
</script>
